import React from 'react';
import bg from '../../../Assets/Images/Wallpaper1.jpg';
import "../../../../node_modules/bootstrap/dist/css/bootstrap.min.css";


export default function MetatarsalBar() {

function LegLength() {
    return (
        <div class="row Pages-font-size">
        <div class="col-sm-4 justify-content-center">
        <img class="w-100 rounded mt-2" src={bg} alt=""/>
        </div>
        <div class="col-sm-8  mt-2 mb-5">           
             <p>
             A discrepancy in leg length will usually become obvious to parents as they watch their child grow and begin to crawl and walk. Some children are born with legs of different lengths. In other cases, illness or injury causes a discrepancy in length to develop over time. While a slight difference in leg length may not cause symptoms, a significant difference can cause a noticeable limp and make it difficult for a child to run and play. 
             <br/>
 Treatment for a discrepancy depends upon the severity. In many cases, a minor difference in leg length can be evened out by wearing a lift in one shoe. A child with a more significant difference, however, may benefit from surgery to make his or her legs the same length. 

              <br/>
             </p>
             <h4>Previous Injury to a Bone in the Leg  </h4>
             <p>
             A broken leg bone can lead to a limb length discrepancy if it heals in a shortened position. This is more likely to happen if the bone was broken into many pieces. It is also more likely to happen if the skin and muscle tissue around the bone were severely injured and exposed, as occurs in an open fracture. In a child, a broken bone sometimes grows faster for several years after healing, causing it to become longer than the bone on the opposite side. This type of overgrowth occurs most often in young children with femur (thighbone) fractures. 
        
Alternatively, a break in a child's bone through the growth plate near the end of the bone may cause slower growth, resulting in a shorter leg. 
<br/>
             </p>  
             <h4>Bone Infection </h4>
             <p>Bone infections that occur in growing children may cause a significant limb length discrepancy. This is especially true if the infection happens in infancy. 
             <br/><br/>
Certain bone diseases may also cause limb length discrepancy. 
</p><br/>
             <h4>Symptoms </h4>
             <p>Patients who have differences of 3.5 to 4 percent of total leg length (about 4 cm or 2/3 inches in an average adult) may limp or have other difficulties when walking. Because these differences require the patient to exert more effort to walk, he or she may tire easily. </p><br/>
             <h4>Nonsurgical Treatment </h4>
             <p>For patients with minor limb length discrepancies (less than 1 inch) and no deformity, treatment is usually nonsurgical in nature. Because the risks of surgery may outweigh the benefits, surgical treatment to equalize small differences in leg length is not usually recommended. 
</p><br/>
             <h4>Nonsurgical treatments may include: </h4>
             <p>Observation. If your child has not yet reached skeletal maturity, your doctor may recommend simple observation until growing is complete. During this time, your child will be reevaluated at regular intervals to determine whether the discrepancy is increasing or remaining the same. 
             <br/><br/>
Wearing a shoe lift. A lift fitted to the inside or outside of the shoe can often improve a patient's ability to walk and run. A shoe lift may also relieve back pain caused by a smaller limb length discrepancy. Shoe lifts are inexpensive and can be removed easily if they are not effective. 
<br/><br/>
Insoles help to correct limb length discrepancy easily . The patient is able to walk without limping with correction insoles. Correction is possible for varying lengths with Insoles. Also, our insoles neatly fit inside the shoe or footwear and is not easily identifiable. 
</p> <br/>
             <h4>Surgical Treatment </h4>
             <p>Please consult a doctor for detailed information on corrections with surgery.</p>
        </div>
        </div>
    );
  }

  function DiabeticFootUlcer() {
   return (
       <div class="row">
       <div class="col-sm-4 justify-content-center">
       <img class="w-100 rounded mt-2" src={bg} alt=""/>
       </div>
       <div class="col-sm-8  mt-2 mb-5">   
       <h4>DIABETIC FOOT ULCER</h4>     
            <p>
            Diabetic foot ulcer is a major complication of diabetes mellitus.
            <br/>
Ulcers form due to a combination of factors, such as lack of feeling in the foot, poor circulation, foot deformities, irritation (such as friction or pressure), and trauma, as well as the duration of diabetes. Your podiatrist can test feet for neuropathy with a simple, painless tool.
<br/><br/>
In people who have good circulation and good medical care, an ulcer sometimes can heal in as few as three to six weeks. Deeper ulcers may take 12 to 20 weeks.
<br/><br/>
A diabetic foot is a foot that exhibits any pathology that results directly from diabetes mellitus or any long-term or chronic complication of diabetes mellitus. Due to the peripheral nerve dysfunction associated with diabetes (diabetic neuropathy), patients have a reduced ability to feel pain.
<br/><br/>
Our insoles also provides the necessary arch support for the weak arches in diabetic patients. The patient is advised to walk regularly using our customized insoles to aid in circulation. Our footwear is made with anti-bacterial and anti-fungal lining to prevent infections. Also, our footwear is designed to have no sharp corners to prevent rubbing and subsequent bruises or injury.
  
             
            </p>
            <h4>DIABETES AND COMMON FOOT PROBLEMS </h4>
            <p>
Diabetic patients, having higher level of glucose (sugar) in their blood for a long time can cause some serious health issues, including foot problems.</p><br/>
<h4>How Can Diabetes Affect Your Feet?</h4>

<p>Diabetes can cause two major problems that can affect your feet:</p><br/>  
<h4>Diabetic neuropathy:</h4> 
<p>Uncontrolled diabetes can damage your nerves system. 
  If you have damaged nerves in your legs and feet, you might not feel heat, cold, or pain.
   This is called “sensory diabetic neuropathy.” If you do not feel a cut or sore on your foot 
   because of neuropathy, the cut could get worse and become infected. The muscles of the foot
    may not function properly, because the nerves that make the muscles work are damaged. This
     could cause the foot to not align properly and create too much pressure in one area of the foot.
      It is estimated that up to 10% of diabetic patients will develop foot ulcers. Foot ulcers occur 
      because of nerve damage and peripheral vascular disease. Use Micro Cellular Rubber (MCR)
   footwear or Micro Cellular Polymer (MCP) footwear to prevent diabetic neuropathy.</p><br/>
<h4>Peripheral vascular disease:</h4>
<p> Diabetes also affects the flow of blood. Without good blood flow, it takes
   longer for a sore or cut to heal. Poor blood flow in the arms and legs is called “peripheral vascular
    disease.” Peripheral vascular disease is a circulation disorder that affects blood vessels away from
     the heart. If you have an infection that will not heal because of poor blood flow, you are at risk
      for developing ulcers or the death of tissue due to a lack of blood. Use cushioned pads and insoles 
      in your shoes or use MCR/MCP footwear.
  </p> <br/>

            <h4>Other Common Foot Problems with Diabetes:</h4>

            <p>
            Anyone can get the foot problems listed below. For people with diabetes, however, these common foot problems can possibly lead to infection and serious health issues such as
Athlete's foot is a fungus that causes itching, redness, and cracking. Germs can enter through the cracks in your skin and cause an infection. Medicines that kill the fungus are used to treat athlete's foot. These medicines may be pills and/or creams applied directly to the problem area. Athlete patients should use Micro Cellular Rubber (MCR) footwear or Micro Cellular Polymer (MCP) footwear.
Calluses is a build-up of hard skin, usually on the underside of the foot. Calluses are caused by an uneven distribution of weight, generally on the bottom of the forefoot or heel. Calluses also can be caused by improperly fitting shoes or by a skin abnormality. Keep in mind that some degree of callus formation on the sole of the foot is normal. Proper care is necessary if you have a callus. After your bath or shower, use a pumice stone to gently remove the build-up of tissue. Use cushioned pads and insoles in your shoes or use MCR/MCP footwear. Medications also may be prescribed to soften calluses. DO NOT try to cut the callus or remove it with a sharp object
Corn is a build-up of hard skin near a bony area of a toe or between toes.</p>
 <p>Corns may be the result of pressure from shoes that rub against the toes or cause friction between the toes. Proper care is necessary if you have a corn - use cushioned pads and insoles in your shoes or use MCR/MCP footwear. After your bath or shower, use a pumice stone to gently remove the build-up of tissue. Do not use over-the-counter remedies to dissolve corns. DO NOT try to cut the corn or remove it with a sharp object.
Blisters can form when your shoes rub the same spot on your foot. Wearing shoes that do not fit properly or wearing shoes without socks can cause blisters, which can become infected. When treating blisters, it's important not to “pop” them. The skin covering the blister helps protect it from infection. Use an antibacterial cream and clean, soft bandages to help protect the skin and prevent infection. Also, use cushioned pads and insoles in your shoes or use MCR/MCP footwear.
Bunion forms when your big toe angles in toward the second toe. Often, the spot where your big toe joins the rest of the foot becomes red and callused. </p>
<p>This area also may begin to stick out and become hard. Bunions can form on one or both feet. They may run in the family, but most often are caused by wearing high-heeled shoes with narrow toes. These shoes put pressure on the big toe, pushing it toward the second toe. The use of cushioned pads and insoles in your shoes or use MCR/MCP footwear may help protect the bunion from irritation.
Hammertoe is a toe that is bent because of a weakened muscle. The weakened muscle makes the tendons shorter, causing the toes to curl under the feet. Hammertoes can run in families. They can also be cause by shoes that are too short. Hammertoes can cause problems with walking and can lead to other foot problems, such as blisters, calluses, and sores. The use of cushioned pads and insoles in your shoes or use MCR/MCP footwear may help protect the hammertoe from irritation.
</p> <br/>

<h4>PREVENTIVE PROCEDURES</h4>

<p>
Along with treating diabetic foot conditions, there are other things we can do to prevent further problems. If you’ve had foot or vascular surgery to correct a problem, we’ll monitor you over the months and years after.
If we determine at some point down the road that there’s a new area of pressure developing, we may be able to correct it before it becomes a problem. Surgical examples include tendon lengthening or osteotomy, in which we cut or reshape a bone to relieve pressure.</p>
<p>We also may be able to avoid surgery with a non-invasive procedure. If, for example, you have hammertoe, in which the toe bends downward causing repeated ulcers on the tip of the toe, we could perform a percutaneous needle tenotomy. In this procedure, we use a needle to release part of the tendon from the bone.
Diabetes care doesn’t stop at controlling blood sugar. If you or a loved one has diabetes, get in the habit of practicing proper foot care, scheduling regular check-ups and seeking early treatment for problems to prevent serious diabetic foot complications, including amputation.
Last but not the least, use MCR footwear to prevent your feet from all the above foot problems.

</p><br/> 
<h4>Diabetic Foot Care Tips:</h4>                           
<ol>                                            
   <li>Diabetic patients need to care their feet daily</li>
   <li>Avoid using Pointed Shoes</li>
   <li>Its Important to check is there any Cut or Infection on daily basis</li>
   <li>Avoid using Hot waters to wash your feet will damage your skin, Safe hot water level should be 32 degree C to 35 degree C</li>
   <li>Dry your feet well using a soft cloth</li>
   <li>Apply soft lotion top and bottom of feet to keep the skin soft.</li>
   <li>Avoid using Heating pads</li>
   <li>Keep your blood glucose level targeted range</li>
   <li>Use MCR Footwear/Slippers or Chappals or Sandals and Diabetic Shoes to take care of your feet.</li>
</ol><br/>
<h4>How to Right Choose Diabetic Shoes or MCR Based Shoes</h4>
<ol>
   <li>Buy Shoes with Flat Toe, Avoid Narrow Toe</li>
   <li>Choose Shoes with Padding collar, This will help to prevent the friction and secure your foot.</li>
   <li>Productive Toe area</li>
   <li>Build in Heel counter for Stability</li>
</ol><br/>
<p>
MCR and MCP footwear’s are made of premium quality Micro Cellular Rubber and Micro Cellular Polymer, which will help diabetic patients to prevent from diabetic neuropathy, peripheral vascular disease and other diabetic foot problems. MCR Slippers and Shoes are ideal for Heel Pain, Back Pain, Knee Pain and Leg Pain.
<br/><br/>
Our products are scientifically designed, Unique, Soft, Flexible and provides extra comfort for your feet. Benefits of our product will provides to diabetes patients, including many of who suffer from poor blood circulation in their feet.

</p><br/>

<h4>Benefits of MCR Chappals / MCP Slippers/ MCR Footwear and MCR based Diabetic Shoes:</h4>

<p>
Generally Micro Cellular Rubber Footwear or MCR Footwear used to heal Diabetic foot Problems, Foot Pain, Arch Pain and Back pain. Also it will provide following health benefits
</p><br/>

<ol>
   <li>Microcellular Rubber Footwear or MCR Footwear used to cure Diabetic Problems, Foot Pain, Arch Pain and Back pain</li>
   <li>Flat Foot causes Serious health problem</li>
   <li>MCR Slippers and Insoles absorb shocks from eternal forces</li>
   <li>MCR Based Arch Insoles prevent the friction</li>
   <li>Arch Support footwear or Insole can prevent the Flat Foot Problems</li>
   <li>Plantar Fasciitis (High Arch) Problem</li>
   <li>Metatarsalgia (Toe Muscle Pain) Problem</li>
   <li>Bunlon (Narrow Toe) problem</li>
   <li>+Morton’s Neuroma (Leg Fingers Pain) Problem</li>
   <li>Hallux Rigidus (Leg Tamp Finger Pain) Problem</li>
   <li>Lower Back Pain</li>
   <li>Corns (hard Skin Over Leg Toe Area)</li>
   <li>Calluses (hard Skin bottom of the feet area)</li>
   <li>Diabetic Foot Care</li>
   <li>Heel Pain</li>
</ol>
       </div>
       </div>
   );
 }


 

  return (
      <div className="container Pages-font-size">
      <h1 class="mt-5 text-center">BUNION & OVERLAPPING TOES</h1><br/>
        <h2>METARTASAL BAR / FOREFOOT ROCKER SOLES</h2> 
      <p>
      A hallux valgus deformity, commonly called a bunion, is when there is medial deviation of t
      he first metatarsal and lateral deviation of the great toe (hallux). The condition can lead 
      to painful motion of the joint. Hallux valgus is the commonest forefoot deformity, with an estimated prevalence of around 30%.
 It causes symptoms on the medial edge of the foot, the sole, and the small toes. Non-operative 
 treatment may alleviate symptoms but does not correct the deformity of the big toe. 
</p><br/>

      <h1>LEG LENGTH DISCREPENCY</h1>
        <LegLength/>

      <h1>DIABETICS FOOT CONDITIONS</h1>
        <DiabeticFootUlcer/>


      </div>
  );
}